var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3117_3677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3117_3677",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 5.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3117_3677)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5781 10.9941C12.5781 10.773 12.4903 10.5608 12.3339 10.4044C12.1775 10.248 11.9653 10.1602 11.7441 10.1602C11.523 10.1602 11.3108 10.248 11.1544 10.4044C10.998 10.5608 10.9102 10.773 10.9102 10.9941V25.3387C10.9102 25.7368 11.0683 26.1186 11.3498 26.4002C11.6314 26.6817 12.0132 26.8398 12.4113 26.8398H26.7559C26.977 26.8398 27.1892 26.752 27.3456 26.5956C27.502 26.4392 27.5898 26.227 27.5898 26.0059C27.5898 25.7847 27.502 25.5725 27.3456 25.4161C27.1892 25.2597 26.977 25.1719 26.7559 25.1719H12.5781V10.9941ZM27.3455 14.9197C27.4974 14.7624 27.5815 14.5517 27.5796 14.3331C27.5777 14.1144 27.49 13.9052 27.3353 13.7506C27.1807 13.596 26.9715 13.5083 26.7529 13.5064C26.5342 13.5045 26.3235 13.5885 26.1662 13.7405L20.918 18.9887L18.1717 16.2424C18.0153 16.0861 17.8032 15.9982 17.582 15.9982C17.3609 15.9982 17.1488 16.0861 16.9924 16.2424L13.6565 19.5783C13.5768 19.6553 13.5133 19.7473 13.4696 19.849C13.4259 19.9508 13.4029 20.0602 13.4019 20.171C13.4009 20.2817 13.422 20.3915 13.464 20.494C13.5059 20.5965 13.5678 20.6896 13.6461 20.7679C13.7244 20.8462 13.8176 20.9082 13.92 20.9501C14.0225 20.992 14.1324 21.0131 14.2431 21.0122C14.3538 21.0112 14.4633 20.9882 14.565 20.9445C14.6668 20.9008 14.7588 20.8372 14.8357 20.7576L17.582 18.0113L20.3283 20.7576C20.4847 20.9139 20.6968 21.0018 20.918 21.0018C21.1391 21.0018 21.3512 20.9139 21.5076 20.7576L27.3455 14.9197Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3117_3677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.3728994f1ee960085bb6115c37fa15f0.svg";
export { ForwardRef as ReactComponent };